import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ResourcesManagementView } from "src/components/views/spc/masterData/resources/ResourcesManagementView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/resources")({
	staticData: { title: i18n.t("resources"), legacyViewKey: "resourcesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ResourcesManagementView />;
}
